/* ============================================================
   Alycia's Jewelry — theme JS (v1.0)
   Vanilla JS, no dependencies.
   ============================================================ */
(function () {
  'use strict';

  var money = function (cents) {
    return (window.Alycia && window.Alycia.formatMoney)
      ? window.Alycia.formatMoney(cents)
      : '$' + (cents / 100).toFixed(2);
  };

  /* ---------- Generic open/close for panels ---------- */
  function openPanel(el, scrim) {
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var focusable = el.querySelector('a,button,input,textarea,select');
    if (focusable) focusable.focus();
  }
  function closePanel(el, scrim) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  var scrim = document.querySelector('[data-drawer-scrim]');
  var navDrawer = document.getElementById('mobile-drawer');
  var cartDrawer = document.getElementById('cart-drawer');

  document.addEventListener('click', function (e) {
    var openNav = e.target.closest('[data-open-nav]');
    var openCart = e.target.closest('[data-open-cart]');
    var closeBtn = e.target.closest('[data-close-drawer]');
    if (openNav) { e.preventDefault(); openPanel(navDrawer, scrim); }
    if (openCart) { e.preventDefault(); openPanel(cartDrawer, scrim); }
    if (closeBtn) { closePanel(navDrawer, scrim); closePanel(cartDrawer, scrim); }
    if (e.target === scrim) { closePanel(navDrawer, scrim); closePanel(cartDrawer, scrim); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closePanel(navDrawer, scrim); closePanel(cartDrawer, scrim); }
  });

  /* ---------- Accordions (PDP + facets already use <details>) ---------- */
  document.querySelectorAll('.acc__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.acc__item');
      var open = item.getAttribute('aria-expanded') === 'true';
      item.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var wrap = step.closest('.qty');
    var input = wrap.querySelector('input');
    var val = parseInt(input.value, 10) || 1;
    val += parseInt(step.getAttribute('data-qty-step'), 10);
    if (val < 1) val = 1;
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- PDP: gallery thumbnails ---------- */
  var mainImg = document.getElementById('pdp-main-image');
  document.querySelectorAll('[data-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      if (mainImg) { mainImg.src = t.getAttribute('data-full'); mainImg.alt = t.querySelector('img') ? t.querySelector('img').alt : ''; }
      document.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  /* ---------- PDP: variant selection ---------- */
  var form = document.querySelector('.product-form');
  if (form) {
    var dataEl = document.getElementById('product-variants-json');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var idInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare]');
    var addBtn = form.querySelector('[data-add-btn]');
    var addBtnLabel = addBtn ? addBtn.querySelector('[data-add-label]') : null;

    function currentOptions() {
      var opts = [];
      form.querySelectorAll('[data-option-index]').forEach(function (input) {
        if (input.type === 'radio' || input.type === 'checkbox') {
          if (input.checked) opts[+input.getAttribute('data-option-index')] = input.value;
        } else {
          opts[+input.getAttribute('data-option-index')] = input.value;
        }
      });
      return opts;
    }
    function matchVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function updateVariant() {
      var v = matchVariant(currentOptions());
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price); compareEl.classList.remove('hidden');
        } else { compareEl.classList.add('hidden'); }
      }
      // reflect chosen swatch label
      form.querySelectorAll('[data-option-value-label]').forEach(function (lbl, i) {
        lbl.textContent = v.options[+lbl.getAttribute('data-option-value-label')] || '';
      });
      if (addBtn) {
        if (v.available) { addBtn.disabled = false; if (addBtnLabel) addBtnLabel.textContent = 'Add to Bag'; }
        else { addBtn.disabled = true; if (addBtnLabel) addBtnLabel.textContent = 'Sold Out'; }
      }
      // update URL for shareability
      if (history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u.toString());
      }
    }
    form.querySelectorAll('[data-option-index]').forEach(function (input) {
      input.addEventListener('change', updateVariant);
    });
    updateVariant();
  }

  /* ---------- Gift toggle (PDP) ---------- */
  document.querySelectorAll('[data-gift-toggle]').forEach(function (cb) {
    function sync() {
      var target = document.querySelector(cb.getAttribute('data-gift-toggle'));
      if (!target) return;
      target.classList.toggle('hidden', !cb.checked);
      target.querySelectorAll('textarea,input').forEach(function (el) { el.disabled = !cb.checked; });
    }
    cb.addEventListener('change', sync);
    sync();
  });

  /* ---------- AJAX add to cart ---------- */
  function refreshCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.setAttribute('data-count', cart.item_count);
      });
      renderDrawer(cart);
      updateFreeShip(cart.total_price);
      return cart;
    });
  }

  function renderDrawer(cart) {
    var body = document.querySelector('[data-cart-drawer-body]');
    var footTotal = document.querySelector('[data-drawer-total]');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<p class="center text-soft" style="padding:40px 0">Your bag is empty.</p>';
      if (footTotal) footTotal.textContent = money(0);
      return;
    }
    body.innerHTML = cart.items.map(function (item) {
      var props = (item.properties && Object.keys(item.properties).length)
        ? '<p class="line-item__props">' + Object.keys(item.properties).filter(function (k) { return k[0] !== '_' && item.properties[k]; }).map(function (k) { return k + ': ' + item.properties[k]; }).join('<br>') + '</p>'
        : '';
      return '<div class="line-item">' +
        '<div class="line-item__media"><img src="' + (item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '') + '" alt="' + item.product_title + '" loading="lazy"></div>' +
        '<div><h3 class="line-item__title">' + item.product_title + '</h3>' +
        (item.variant_title ? '<p class="line-item__variant">' + item.variant_title + '</p>' : '') + props +
        '<div class="qty" style="margin-top:10px"><button type="button" data-line-change="' + item.key + '" data-line-qty="' + (item.quantity - 1) + '" aria-label="Decrease">&minus;</button><input value="' + item.quantity + '" readonly aria-label="Quantity"><button type="button" data-line-change="' + item.key + '" data-line-qty="' + (item.quantity + 1) + '" aria-label="Increase">+</button></div>' +
        '<button class="line-item__remove" data-line-change="' + item.key + '" data-line-qty="0">Remove</button></div>' +
        '<div class="line-item__price">' + money(item.final_line_price) + '</div>' +
        '</div>';
    }).join('');
    if (footTotal) footTotal.textContent = money(cart.total_price);
  }

  document.addEventListener('submit', function (e) {
    var f = e.target.closest('.product-form');
    if (!f) return;
    e.preventDefault();
    var btn = f.querySelector('[data-add-btn]');
    if (btn) { btn.disabled = true; }
    var fd = new FormData(f);
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCart(); })
      .then(function () { openPanel(cartDrawer, scrim); if (btn) btn.disabled = false; })
      .catch(function () { if (btn) btn.disabled = false; f.submit(); });
  });

  /* ---------- Line qty change inside drawer ---------- */
  document.addEventListener('click', function (e) {
    var change = e.target.closest('[data-line-change]');
    if (!change) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: change.getAttribute('data-line-change'), quantity: +change.getAttribute('data-line-qty') })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.setAttribute('data-count', cart.item_count); });
      renderDrawer(cart); updateFreeShip(cart.total_price);
      if (document.body.classList.contains('template-cart')) window.location.reload();
    });
  });

  /* ---------- Add gift wrap from cart / drawer ---------- */
  document.addEventListener('change', function (e) {
    var gw = e.target.closest('[data-giftwrap-variant]');
    if (!gw) return;
    var vid = gw.getAttribute('data-giftwrap-variant');
    if (gw.checked) {
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: +vid, quantity: 1, properties: { '_gift_wrap': 'yes' } }] }) })
        .then(refreshCart);
    } else {
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: +vid, quantity: 0 }) })
        .then(refreshCart);
    }
  });

  /* ---------- Free shipping bar ---------- */
  function updateFreeShip(total) {
    var bars = document.querySelectorAll('[data-freeship]');
    bars.forEach(function (bar) {
      var threshold = +bar.getAttribute('data-freeship') || 0;
      var fill = bar.querySelector('.freeship__fill');
      var msg = bar.querySelector('[data-freeship-msg]');
      if (threshold <= 0) return;
      var pct = Math.min(100, (total / threshold) * 100);
      if (fill) fill.style.width = pct + '%';
      if (msg) {
        if (total >= threshold) msg.innerHTML = 'You have unlocked <strong>complimentary shipping</strong>.';
        else msg.innerHTML = 'You are <strong>' + money(threshold - total) + '</strong> away from free shipping';
      }
    });
  }

  /* ---------- Sort redirect ---------- */
  document.querySelectorAll('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sel.value);
      window.location.href = u.toString();
    });
  });

  /* ---------- Product recommendations (Shopify Recommendations API) ---------- */
  document.querySelectorAll('[data-recommendations]').forEach(function (el) {
    var pid = el.getAttribute('data-product-id');
    var intent = el.getAttribute('data-intent') || 'related';
    var limit = el.getAttribute('data-limit') || 4;
    var sid = el.getAttribute('data-section-id');
    var url = '/recommendations/products?product_id=' + pid + '&limit=' + limit + '&intent=' + intent + '&section_id=' + sid;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var inner = doc.querySelector('[data-recommendations-inner]');
      if (inner && inner.children.length) { el.innerHTML = inner.innerHTML; el.closest('[data-recommendations-section]').classList.remove('hidden'); }
    });
  });

  /* Initialise free-ship bar on load */
  var initTotal = document.querySelector('[data-cart-total-cents]');
  if (initTotal) updateFreeShip(+initTotal.getAttribute('data-cart-total-cents'));
})();
